import PropTypes from "prop-types";
import { memo } from "react";
import DepartureCity from "./DepartureCity.jsx";
import "./departure-city.scss";
import { FormattedMessage } from "react-intl";

const DepartureCityList = ({
	departureCities = [],
	field = {},
	onDepartureCityChange,
	productInfo,
	showCTA,
}) => {
	let departureCitiesNode = departureCities.map(departureCity => {
		return (
			<div key={departureCity.code} className="departure-city__item">
				<DepartureCity
					productInfo={productInfo}
					amountSuffix={
						<FormattedMessage id="general.amount.per.person.suffix.label.short" />
					}
					departureCity={departureCity}
					field={field}
					showCTA={showCTA}
					onChange={onDepartureCityChange}
					data-testid={`search-engine-departure-city-${departureCity.code}`}
				/>
			</div>
		);
	});

	return <div className="departure-city__list">{departureCitiesNode}</div>;
};

DepartureCityList.propTypes = {
	productInfo: PropTypes.object,
	departureCities: PropTypes.array,
	field: PropTypes.object,
	onDepartureCityChange: PropTypes.func,
	showCTA: PropTypes.bool,
};

export default memo(DepartureCityList);
